import { apiClient, type ApiClientResponse, routes } from 'common/services';

type UpdateUserProfileRequestData = {
  first_name?: string;
  last_name?: string;
  phone?: string;
  birthdate?: string;
};

export const updateUserProfile = async (userId: string, data: UpdateUserProfileRequestData) =>
  apiClient.patch<unknown, ApiClientResponse<unknown>>(routes.user.patch(userId), {
    user: data,
  });
